
import {Directive, HostBinding, HostListener, Input, Attribute, Injectable } from '@angular/core';

@Injectable()
export class NavigationCountService {

  private navigationCount : number = 0 ;

  constructor() {
  }

  public get count() : number {
    return this.navigationCount ;
  }

  public increament() : number {
    return ++this.navigationCount ;
  }

  public reset() : void {
    this.navigationCount = 0 ;
  }

}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/navigation/navigation-count-service.ts